import { render, staticRenderFns } from "./AlertDialogWrapper.vue?vue&type=template&id=ebb846da&scoped=true&"
import script from "./AlertDialogWrapper.vue?vue&type=script&lang=ts&"
export * from "./AlertDialogWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDialogWrapper.vue?vue&type=style&index=0&id=ebb846da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb846da",
  null
  
)

export default component.exports